import { IViewModel } from '../../interfaces/view-model.interface';

export class UserWorkflowTransition implements IViewModel {
    public id: number; // Has not mean for this class.

    public workflowTransitionId: number;
    public worflowTransitionName: string;

    public startWorkflowState: string;
    public endWorkflowState: string;
}
